var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9C19.8387 9 23 12.1613 23 16C23 19.8669 19.8387 23 16 23C12.1331 23 9 19.8669 9 16C9 12.1613 12.1331 9 16 9ZM19.2177 13.7702C19.246 13.6855 19.246 13.6008 19.2177 13.4879C19.2177 13.4315 19.1613 13.3468 19.1331 13.3185C19.0484 13.2339 18.9073 13.2339 18.8508 13.2339C18.5968 13.2339 18.1734 13.375 16.2258 14.1935C15.5484 14.4758 14.1935 15.0403 12.1613 15.9435C11.8226 16.0847 11.6532 16.1976 11.625 16.3387C11.5968 16.5645 11.9637 16.6492 12.3871 16.7903C12.754 16.9032 13.2339 17.0444 13.4879 17.0444C13.7137 17.0444 13.9677 16.9597 14.25 16.7621C16.1411 15.4637 17.129 14.8145 17.1855 14.8145C17.2419 14.8145 17.2984 14.7863 17.3266 14.8145C17.3831 14.871 17.3831 14.9274 17.3548 14.9556C17.3266 15.0968 15.5484 16.7339 15.4355 16.8468C15.0403 17.2419 14.5887 17.496 15.2944 17.9476C15.8871 18.3427 16.2258 18.5968 16.8468 18.9919C17.2419 19.246 17.5524 19.5565 17.9476 19.5282C18.1452 19.5 18.3427 19.3306 18.4274 18.7944C18.6815 17.5806 19.1331 14.871 19.2177 13.7702Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.ebf3afb98b874e7fe33826cdd9215043.svg";
export { ForwardRef as ReactComponent };